export default __webpack_public_path__ + "static/media/kiali.b32f7586.png";